import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { ROLE } from '../constant/role';
import { isDesktop, isProbablyPhone, isProbablyTablet } from '../constant/functions';

export const registrationGuard: CanActivateFn = async (route, state) => {

  const router = inject(Router);
  const storage = inject(StorageService);

  await storage.init();
  let token = await storage.isAuthenticated();
  
  if (!token) {
    if (state.url.includes('/auth')) {
      return true;
    }
    return router.navigateByUrl('/auth/login');
  } else {
    let role: string[] = await storage.getRole();
    
    // console.log('Executed', state.url);
    if (role.includes(ROLE.SOCIELITEADMIN)) {
      if (state.url.includes('/socielite-admin') && !isDesktop()) {
        return router.navigate(['/no-mobile', 'mobile/tablet']);
      }
      return state.url.includes('auth') ? router.navigateByUrl('/socielite-admin') : (state.url.includes('/socielite-admin') || router.navigate(['/restricted', state.url]));
    }
    if (role.includes(ROLE.UNIVERSITYADMIN)) {
      if (state.url.includes('/university-admin') && !isDesktop()) {
        return router.navigate(['/no-mobile', 'mobile/tablet']);
      }
      return state.url.includes('auth') ? router.navigateByUrl('/university-admin') : (state.url.includes('/university-admin') || router.navigate(['/restricted', state.url]));
    }
    if (role.includes(ROLE.STUDENT)) {
      if ((state.url.includes('/student-su') || state.url.includes('/student-sa')) && isProbablyPhone()) {
        return router.navigate(['/no-mobile', 'mobile']);
      }
      return state.url.includes('auth') ? router.navigateByUrl('/student') : (state.url.includes('/student') || router.navigate(['/restricted', state.url]));
    }

    return router.navigate(['/restricted', state.url]);
  }
  
};
